"use strict";
/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

/**
 * [exports description]
 * @param  {[type]} config [description]
 * @param  {[type]} get    [description]
 * @param  {[type]} post   [description]
 * @return {function}  associate  associate user with machine serial#
 * @return {function}  update  update machine state
 * @return {function}  token  associate machine ser# with a session token
 */
module.exports = function (config, get, post) {

	return {
		associate: associate,
		update: update,
		token: token
	};

	/**
	 * Associates a user with a machine's serial
	 * @param  {String}  serial Machine's serial number
	 * @param  {String}  apk    The APK version of the app
	 * @return {Promise}        Resolves if association was successful
	 */
	function associate(serial, apk) {
		return post("/v2/machine/associate", {
			serial: serial,
			apk: apk
		});
	}

	/**
	 * Updates the state of a machine
	 * @param  {String}  serial The machine's serial number
	 * @param  {String}  state  What state the machine is now in
	 * @return {Promise}        Resolves if update was successful
	 */
	function update(serial, state) {
		return post("/v2/machine/update", {
			serial: serial,
			state: state
		});
	}

	/**
	 * Associate machine ser# with a session token
	 * @param  {[type]} serial [description]
	 * @return {[type]}        [description]
	 */
	function token(serial) {
		return post("/v2/machine/token", {
			serial: serial
		});
	}
};
